(() => {
  const route = '/apps/17track';

  if (window.location.pathname.toLowerCase() !== route) return;

  const config = document.getElementById('shanzhui-track-guidance-config');

  if (!config) return;

  const rootSelector = '#yq-tracking-form, .yq-tracking-form';
  const getRoot = () => document.querySelector(rootSelector);
  const getOrderInput = (root) =>
    root?.querySelector('#orderForm_order_no, input[aria-label="Order Number"], input[aria-label="订单编号"]');
  const getTrackingInput = (root) =>
    root?.querySelector('input[aria-label="Tracking Number"], input[aria-label="物流单号"]');

  const enhanceForm = () => {
    const root = getRoot();

    if (!root) return;

    const orderInput = getOrderInput(root);
    const trackingInput = getTrackingInput(root);
    const input = orderInput || trackingInput;

    if (!input) return;

    const isOrderMode = Boolean(orderInput);
    input.placeholder = isOrderMode ? config.dataset.orderPlaceholder : config.dataset.trackingPlaceholder;

    let guidance = root.querySelector('[data-shanzhui-track-guidance]');

    if (!guidance) {
      guidance = document.createElement('p');
      guidance.className = 'shanzhui-track-guidance';
      guidance.dataset.shanzhuiTrackGuidance = '';
      guidance.setAttribute('role', 'note');
      const form = input.closest('form') || input.parentElement;
      form?.insertBefore(guidance, form.firstChild);
    }

    guidance.textContent = isOrderMode ? config.dataset.orderHint : config.dataset.trackingHint;
  };

  const redirectTrackingNumber = (target) => {
    const root = target?.closest?.(rootSelector);
    const orderInput = getOrderInput(root);

    if (!orderInput) return false;

    const value = orderInput.value.trim().replace(/\s+/g, '');

    if (!/^\d{15,30}$/.test(value)) return false;

    window.location.assign(`${route}?nums=${encodeURIComponent(value)}`);
    return true;
  };

  document.addEventListener(
    'submit',
    (event) => {
      if (!redirectTrackingNumber(event.target)) return;
      event.preventDefault();
      event.stopImmediatePropagation();
    },
    true
  );

  document.addEventListener(
    'click',
    (event) => {
      const button = event.target.closest('button');

      if (!button || !redirectTrackingNumber(button)) return;
      event.preventDefault();
      event.stopImmediatePropagation();
    },
    true
  );

  new MutationObserver(enhanceForm).observe(document.body, { childList: true, subtree: true });
  enhanceForm();
})();
